import { deleteApp, getApps, initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import HttpClient from '../../../core/HttpClient';
import { firebaseApp } from '../../../firebase.config';

// Separate app: a sign in on the default one would open a portal session on the reset page.
const RESET_APP_NAME = 'password-reset';

/**
 * After a reset by link, the user picked their own password: clear the marker so the next
 * login does not ask again (LEED-2314). Signing in with the new password proves the reset.
 * Never throws: the reset itself already succeeded.
 */
async function clearPasswordChangeAfterReset(email: string, password: string): Promise<void> {
  const app = getApps().find((oApp) => oApp.name === RESET_APP_NAME) ?? initializeApp(firebaseApp.options, RESET_APP_NAME);
  const auth = getAuth(app);

  try {
    const { user } = await signInWithEmailAndPassword(auth, email, password);
    await HttpClient.put('/user', { uid: user.uid, password_change_required_at: null }, await user.getIdToken());
  } catch (e) {
    console.error('Error clearing password_change_required_at after a reset:', e);
  } finally {
    await signOut(auth).catch(() => undefined);
    await deleteApp(app).catch(() => undefined);
  }
}

export default clearPasswordChangeAfterReset;